import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import {
  SalaProvaRequestDTO,
  SalaProvaResponseDTO
} from '../models/sala-prova.model';

@Injectable({
  providedIn: 'root'
})
export class SalaProvaService {
  private apiUrl = `${environment.apiUrl}/admin/salas-prova`;

  constructor(private http: HttpClient) {}

  /**
   * Criar Sala de Prova
   * POST /api/admin/salas-prova
   */
  criarSalaProva(data: SalaProvaRequestDTO): Observable<SalaProvaResponseDTO> {
    return this.http.post<SalaProvaResponseDTO>(this.apiUrl, data);
  }

  /**
   * Atualizar Sala de Prova
   * PUT /api/admin/salas-prova/{id}
   */
  atualizarSalaProva(id: number, data: SalaProvaRequestDTO): Observable<SalaProvaResponseDTO> {
    return this.http.put<SalaProvaResponseDTO>(`${this.apiUrl}/${id}`, data);
  }

  /**
   * Buscar Sala de Prova por ID
   * GET /api/admin/salas-prova/{id}
   */
  buscarSalaProvaPorId(id: number): Observable<SalaProvaResponseDTO> {
    return this.http.get<SalaProvaResponseDTO>(`${this.apiUrl}/${id}`);
  }

  /**
   * Listar Salas de Prova por Local
   * GET /api/admin/salas-prova/local/{localProvaId}
   */
  listarSalasPorLocal(localProvaId: number): Observable<SalaProvaResponseDTO[]> {
    return this.http.get<SalaProvaResponseDTO[]>(`${this.apiUrl}/local/${localProvaId}`);
  }

  /**
   * Listar Salas de Prova por Edital
   * GET /api/admin/salas-prova/edital/{editalId}
   */
  listarSalasPorEdital(editalId: number): Observable<SalaProvaResponseDTO[]> {
    return this.http.get<SalaProvaResponseDTO[]>(`${this.apiUrl}/edital/${editalId}`);
  }

  /**
   * Deletar Sala de Prova
   * DELETE /api/admin/salas-prova/{id}
   */
  deletarSalaProva(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
